<div [ngSwitch]="aPanelData.style">
    <div *ngSwitchCase="'none'">
        <pnl-none [aPanelData]="aPanelData"></pnl-none>
    </div>    
    <div *ngSwitchCase="'default-unbordered'">
        <pnl-default-unbordered [aPanelData]="aPanelData"></pnl-default-unbordered>
    </div>
    <div *ngSwitchCase="'high-title'">
        <pnl-high-title [aPanelData]="aPanelData"></pnl-high-title>
    </div>
    <div *ngSwitchCase="'profile-card4'">
        <pnl-profile-card4 [aPanelData]="aPanelData"></pnl-profile-card4>
    </div>
    <div *ngSwitchDefault>
        <pnl-default [aPanelData]="aPanelData"></pnl-default>
    </div>
</div>